import { AcademicYearOption } from '../types';

export const createAcademicYearsSelectOptions = (academicYears: string[]): AcademicYearOption[] =>
  academicYears.map((academicYear) => ({
    label: academicYear,
    value: academicYear,
  }));
